import * as yup from 'yup'
import { TYPE_EMAIL_INVALID, TYPE_REQUIRED } from 'constants/errors'

const schema = yup.object().shape({
  phone: yup.string().matches(/^$|(.*\d.*){10}/, 'Must be 10 digits'),
  contact_email: yup.string().required(TYPE_REQUIRED).email(TYPE_EMAIL_INVALID),
})
export default schema
